import { render, staticRenderFns } from "./LlScrollableBlock.vue?vue&type=template&id=b42af1de&scoped=true"
import script from "./LlScrollableBlock.vue?vue&type=script&lang=js"
export * from "./LlScrollableBlock.vue?vue&type=script&lang=js"
import style0 from "./LlScrollableBlock.vue?vue&type=style&index=0&id=b42af1de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b42af1de",
  null
  
)

export default component.exports